import { useState, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { Skeleton } from '@/components/ui/Skeleton';

export function AdminRoute() {
  const { user, isAuthenticated } = useAuthStore();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const hydrationBuffer = setTimeout(() => setIsReady(true), 300);
    return () => clearTimeout(hydrationBuffer);
  }, []);

  if (!isReady) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Skeleton className="w-64 h-8" />
      </div>
    );
  }

  const token = localStorage.getItem('auth_access_token');
  const isAuth = isAuthenticated || !!token;

  // Not authenticated → login
  if (!isAuth) {
    return <Navigate to="/login" replace />;
  }

  // Not admin → redirect to profile
  if (user?.role !== 'admin' && user?.role !== 'super_admin') {
    return <Navigate to="/profile" replace />;
  }

  return <Outlet />;
}
